import { CardPendingEvent, DigitalCardStatus } from '@mc-alberta/types';
/**
 * Returns true the card indicates that SCA is required prior to enrolling it into SRC.
 */
export default function isAuthenticationRequired(maskedCard) {
    try {
        return (maskedCard.digitalCardData.status === DigitalCardStatus.PENDING &&
            maskedCard.digitalCardData.pendingEvents.includes(CardPendingEvent.PENDING_SCA));
    }
    catch (error) {
        return false;
    }
}
